import { Link } from 'react-router-dom';
import { i18n as i } from "../../../i18n"
import Exception from '../../../components/Exception';
import noPermissionSvg from "../../../assets/images/403.svg";

function NoPermission(props: any) {
  return (
    <Exception
      type="403"
      desc={i('无访问权限')}
      style={{ minHeight: 500, height: '80%' }}
      linkElement={Link}
      img={noPermissionSvg}
      {...props}
    />
  );
}

export default NoPermission;


